<template>
  <div>
    <div>
      <div class="info row gy-1 info-edit" v-if="!renderHealthQuestionInfo">
        <!-- user name -->
        <div class="scroll-container">
          <div class=" row mt-2 justify-content-between" >
            <span class=" info-display info-name col-lg-6 col-md-6 col-sm-6"></span>

          </div>
          <div class="padding-5">
            <ul class="list-style">
              <li v-for="(conditionQuestion, count) in primaryHealthInfo.condition_questions" :key="count">
                <div class="split">
                  {{conditionQuestion.question_text | removeHtmlTags}}
                  <div class="text-end radioBtn">
                    <div class="form-check form-check-inline mt-2">
                      <input type="radio" :checked="conditionQuestion.yes_no_flag == 1" :disabled="true">
                      <span class="label"> Yes </span>
                    </div>
                    <div class="form-check form-check-inline mt-2">
                      <input type="radio"  :checked="conditionQuestion.yes_no_flag == 0" :disabled="true">
                      <span class="label"> No </span>
                    </div>
                  </div>
                </div>

                <div v-if="conditionQuestion.question_id == 145 || conditionQuestion.question_id == 146 || conditionQuestion.question_id == 147">
                  <div class="disease mb-3" v-if="conditionQuestion.yes_no_flag == 1 && (conditionQuestion.question_id == 146 || conditionQuestion.question_id == 147)">
                    <div >
                      <table cellspacing="0">
                        <tr>
                          <td>Condition</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.condition}}</label>
                          </td>
                        </tr>
                        <tr>
                          <td>Status</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.status}}</label>
                          </td>
                        </tr>
                        <tr>
                          <td>Last Seen By Physician</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.last_seen_by_physician}}</label>
                          </td>
                        </tr>
                        <tr>
                          <td>Date of Recovery</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.date_of_recovery}}</label>
                          </td>
                        </tr>
                        <tr>
                          <td>Physician Name</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.physician_name}}</label>
                          </td>
                        </tr>
                        <tr>
                          <td>Address</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.address}}</label>
                          </td>
                        </tr>
                        <tr>
                          <td>Phone</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.phone}}</label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="disease mb-3" v-if="conditionQuestion.yes_no_flag == 1">
                    <div >
                      <table cellspacing="0">
                        <tr>
                          <td>Condition/Diseases/Diagnosis/Treatment</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.health_condition}}</label>
                          </td>
                        </tr>
                        <tr>
                          <td>Date of Onset</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.date_of_onset}}</label>
                          </td>
                        </tr>
                        <tr>
                          <td>Date of Recovery</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.date_of_recovery}}</label>
                          </td>
                        </tr>
                        <tr>
                          <td>Current Treatment</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.is_treatment == 1 ? 'Yes' : 'No'}}</label>
                          </td>
                        </tr>
                        <tr>
                          <td>Taking Medication</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.is_medicate == 1 ? 'Yes' : 'No'}}</label>
                          </td>

                        </tr>
                        <tr>
                          <td>Date Last Seen By Physician</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.d_last_seen}}</label>
                          </td>

                        </tr>
                        <tr>
                          <td>Remaining Symptoms of Problems? Surgery or Hospitalization</td>
                          <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.symptoms}}</label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <!-- <div v-for="(conditionQuestion, count) in primaryHealthInfo.condition_questions" :key="count">
              <div class="quest">
                  <div class="q_container">
                      <span class="questions">{{conditionQuestion.question_text | removeHtmlTags}}</span>
                      <span class="answer">
                        <input type="radio" :checked="conditionQuestion.yes_no_flag == 1" :disabled="true">
                        <span class="label">Yes</span>
                        <input type="radio"  :checked="conditionQuestion.yes_no_flag == 0" :disabled="true">
                        <span class="label">No</span>
                      </span>
                  </div>
              </div>
              <div v-if="conditionQuestion.question_id == 146 || conditionQuestion.question_id == 147">
                <div class="disease" v-if="conditionQuestion.yes_no_flag == 1">
                    <div >
                    <table cellspacing="0">
                        <tr>
                            <td>Condition</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                                <label>{{condition.condition}}</label>
                            </td>
                        </tr>
                        <tr>
                            <td>Status</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                                <label>{{condition.status}}</label>
                            </td>
                        </tr>
                        <tr>
                            <td>Last Seen By Physician</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.last_seen_by_physician}}</label>
                            </td>
                        </tr>
                        <tr>
                            <td>Date of Recovery</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.date_of_recovery}}</label>
                            </td>
                        </tr>
                        <tr>
                            <td>Physician Name</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.physician_name}}</label>
                            </td>
                        </tr>
                        <tr>
                            <td>Address</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.address}}</label>
                            </td>
                        </tr>
                        <tr>
                            <td>Phone</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.phone}}</label>
                            </td>
                        </tr>
                    </table>
                    </div>
                </div>
              </div>
              <div v-else>
                <div class="disease" v-if="conditionQuestion.yes_no_flag == 1">
                  <div >
                    <table cellspacing="0">
                        <tr>
                            <td>Condition/Diseases/Diagnosis/Treatment</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                                <label>{{condition.health_condition}}</label>
                            </td>
                        </tr>
                        <tr>
                            <td>Date of Onset</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                                <label>{{condition.date_of_onset}}</label>
                            </td>
                        </tr>
                        <tr>
                            <td>Date of Recovery</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                            <label>{{condition.date_of_recovery}}</label>
                            </td>
                        </tr>
                        <tr>
                            <td>Current Treatment</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                              <label>{{condition.is_treatment == 1 ? 'Yes' : 'No'}}</label>
                            </td>
                        </tr>
                        <tr>
                            <td>Taking Medication</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                                <label>{{condition.is_medicate == 1 ? 'Yes' : 'No'}}</label>
                            </td>
                        </tr>
                        <tr>
                            <td>Date Last Seen By Physician</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                                <label>{{condition.d_last_seen}}</label>
                            </td>
                        </tr>
                        <tr>
                            <td>Remaining Symptoms of Problems? Surgery or Hospitalization</td>
                            <td v-for="(condition, count) in conditionQuestion.conditions" :key="count">
                                <label>{{condition.symptoms}}</label>
                            </td>
                        </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="quest" v-if="primaryHealthInfo.medication_question && primaryHealthInfo.medication_question.medications.length > 0">
              <div class="q_container">
                <span class="questions">{{primaryHealthInfo.medication_question.question_text}}</span>
                <span class="answer">
                                        <input type="radio" :checked="primaryHealthInfo.medication_question.yes_no_flag == 1" :disabled="true">
                                        <span class="label">Yes</span>
                                        <input type="radio"  :checked="primaryHealthInfo.medication_question.yes_no_flag == 0" :disabled="true">
                                        <span class="label"> No </span>
                                      </span>
              </div>
            </div>
            <div class="disease mb-3" v-if="primaryHealthInfo.medication_question.yes_no_flag == 1">
              <div >
                <table cellspacing="0">
                  <tr>
                    <td>Medication/Rx injection</td>
                    <td v-for="(medication, count) in primaryHealthInfo.medication_question.medications" :key="count">
                      <label>{{medication.medication}}</label>
                    </td>
                  </tr>
                  <tr>
                    <td>Dosage</td>
                    <td v-for="(medication, count) in primaryHealthInfo.medication_question.medications" :key="count">
                      <label>{{medication.dosage}}</label>
                    </td>
                  </tr>
                  <tr>
                    <td>Medical Condition</td>
                    <td v-for="(medication, count) in primaryHealthInfo.medication_question.medications" :key="count">
                      <label>{{medication.medical_condition}}</label>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="additional_notes">
              <p>Additional Notes</p>
              <textarea class="notes custom-input mb-3" v-model="primaryHealthInfo.notes" :readonly="true" rows="5" cols="50"></textarea>
            </div>
          </div>
        </div>
        <div class="">
            <button @click="renderHealthQuestionInfo = true"
                    class="btn btn-personal-info-edit btn-outline-info info-edit-btn w-100"
            >
              <i class="fas fa-pen me-2"></i>
              Edit Details
            </button>
          </div>
      </div>
      <div v-if="renderHealthQuestionInfo">
        <health-questions     :isRedirectionFromReview="true"
                              @cancelEditInfo="cancelEditInfo"
                              @updatedEditInfo="updatedEditInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import HealthQuestions from "../HealthQuestions";
export default {
  name: "HealthQuestionEdit",
  props: {
    primaryHealthInfo: {
      type: Object
    }
  },
  data () {
    return {
      renderHealthQuestionInfo: false
    }
  },
  components: {
    HealthQuestions
  },
  methods: {
    cancelEditInfo () {
      let app = this
      app.renderHealthQuestionInfo = false
    },
    updatedEditInfo () {
      let app = this
      app.renderHealthQuestionInfo = false
      app.$emit('updatedEditInfo')
    }
  }
}
</script>
<style src="@/assets/css/review_edit.css"></style>
<style scoped>

</style>